import { render, staticRenderFns } from "./FairwaySelect.vue?vue&type=template&id=4e7e4066&"
import script from "./FairwaySelect.vue?vue&type=script&lang=js&"
export * from "./FairwaySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports